"use client";
import {useState} from 'react';
import {Share2} from 'lucide-react';
import {BiteButton,BiteInput} from './bite-ui';

export function BiteReportShare({jobId}:{jobId:string}) {
  const [busy,setBusy]=useState(false),[url,setUrl]=useState(''),[message,setMessage]=useState('');
  const share=async()=>{
    setBusy(true);setMessage('');
    try {
      const link=new URL(`/bite/card/${encodeURIComponent(jobId)}${window.location.hash}`,window.location.origin).href;setUrl(link);
      try{await navigator.clipboard.writeText(link);setMessage('링크를 복사했습니다. 링크를 받은 사람은 이 보고서를 무료로 읽을 수 있습니다.');}
      catch{setMessage('아래 공유 링크를 복사해주세요.');}
    }catch(error){setMessage(error instanceof Error?error.message:'공유 링크를 만들지 못했습니다. 다시 눌러주세요.');}
    finally{setBusy(false);}
  };
  return <div className="bite-report-share"><BiteButton variant="secondary" size="sm" data-track="bite.report.share" onClick={share} disabled={busy}><Share2 aria-hidden="true"/>{busy?'공유 링크 준비 중':'공유하기'}</BiteButton>{(message||url)&&<div className="bite-report-share__result">{message&&<p className="bite-caption" role="status">{message}</p>}{url&&<BiteInput aria-label="보고서 공유 링크" value={url} readOnly onFocus={event=>event.target.select()}/>}</div>}</div>;
}
